import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/_services/app.service';
import { CommonModalComponent } from '../common/common-modal/common-modal.component';
import { DialogComponent } from '../masters/dialog/dialog.component';

@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
  styleUrls: ['./action.component.scss']
})
export class ActionComponent implements OnInit {

  @Input() element: any;
  @Input() pageName: any;

  constructor(
    private dialog: MatDialog,
    private service: AppService,
    private httpClient: HttpClient
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    console.log(this.pageName);
  }

  shareFile(data) {
    const dialogRef = this.dialog.open(DialogComponent, {
      panelClass: 'modal-width',
      autoFocus: false,
      data: { action: 'shareFile', data: data, type: 'single', pageName: this.pageName }
    })
  }
  docViewDetail(data) {
    const dialogRef = this.dialog.open(DialogComponent, {
      panelClass: 'viewdoc-width',
      autoFocus: false,
      data: { action: 'viewDoc', data: data, pageName: this.pageName }
    })
  }
  editDoc(action, data) {
    const dialogRef = this.dialog.open(DialogComponent, {
      panelClass: 'modal-width',
      autoFocus: false,
      data: { action: action, data: data }
    })
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        $('#table1').DataTable().ajax.reload();
      }
    })
  }
  deleteDoc(data) {
    console.log(data);

    const dialogRef = this.dialog.open(CommonModalComponent, {
      width: '300px',
      disableClose: true,
      autoFocus: false,
      panelClass: 'statusClass',
      data: { action: 'delete', statusText: 'Are you sure you want to delete record' }
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.service.postService({ DocumentIds: [data?.documentId] }, 'Document/DocumentDelete').subscribe(response => {
          if (response.body.success) {
            $('#table1').DataTable().ajax.reload();
            this.service.alertPopup('success', response.body.result.transactionMessage.message);
          } else {
            this.service.alertPopup('delete', response.body.result.transactionMessage.message);
          }
        })
      }
    });
  }
}
